export default {
  message_outbox_tab_filter_by_last: "Last",
  message_outbox_tab_filter_by_date: "Range",
  message_outbox_tab_apply_filters: "Apply",
  message_outbox_tab_created_on: "Created On",
  message_outbox_tab_created_by: "Created By",
  message_outbox_tab_message: "Message",
  message_outbox_tab_description: "Description",
  message_outbox_tab_via: "Via",
  message_outbox_tab_to: "To",
  message_outbox_tab_title: "Commands",
  message_outbox_tab_error_load: "Error loading the commands",
  message_outbox_tab_send_command: "Send Command",
  message_outbox_tab_date_range: "Please select a valid date range",
  message_outbox_tab_status: "Status"


};







